export default __webpack_public_path__ + "4dcfce4cc6773c0e6f6fd19ee4e081cb.png";